import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOption } from '@angular/material/core';
import {
    MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PageHeaderComponent } from '@nucleus/ui-base';

/**
 * Generic type-picker dialog. Used today for purge-by-type, but parameterised
 * so other type-driven flows can reuse it. {@code destructive} flips the
 * primary button to a danger tint and shows the warning banner.
 */
export interface DataTypeSelectorDialogData {
    dataTypeList: string[];
    /** Page-header title. Defaults to "Data Type Selector". */
    title?: string;
    /** Subtitle below the title. Defaults to a generic add-row prompt. */
    subtitle?: string;
    /** Material icon for the page header. Defaults to "category". */
    icon?: string;
    /** When true, render the destructive-action warning banner + a warn-tinted
     *  primary button. Use for purge flows where the operator is about to wipe
     *  data they can't get back. */
    destructive?: boolean;
    /** Heading on the warning banner. Only rendered when destructive is true. */
    warningTitle?: string;
    /** Body text on the warning banner. Only rendered when destructive is true. */
    warningMessage?: string;
    /** Primary button label. Defaults to "Continue". */
    confirmLabel?: string;
    /** Material icon for the primary button. Defaults to "check". */
    confirmIcon?: string;
}

@Component({
    selector: 'app-data-type-selector-dialog-box',
    standalone: true,
    templateUrl: './data-type-selector-dialog-box.component.html',
    styleUrl: './data-type-selector-dialog-box.component.css',
    imports: [
        CommonModule, FormsModule,
        MatFormFieldModule, MatInputModule, MatButtonModule,
        MatIconModule, MatTooltipModule,
        MatDialogActions, MatDialogClose,
        MatOption, MatSelect,
        PageHeaderComponent,
    ],
})
export class DataTypeSelectorDialogBoxComponent implements OnInit {
    selectedDataType: string = '';
    dataTypeList: string[] = [];

    title:           string;
    subtitle:        string;
    icon:            string;
    destructive:     boolean;
    warningTitle:    string;
    warningMessage:  string;
    confirmLabel:    string;
    confirmIcon:     string;

    constructor(
        public dialogRef: MatDialogRef<DataTypeSelectorDialogBoxComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DataTypeSelectorDialogData,
    ) {
        this.dataTypeList   = data.dataTypeList;
        this.title          = data.title          ?? 'Data Type Selector';
        this.subtitle       = data.subtitle       ?? 'Pick a UserData type to add a row.';
        this.icon           = data.icon           ?? 'category';
        this.destructive    = data.destructive    ?? false;
        this.warningTitle   = data.warningTitle   ?? 'This action cannot be undone';
        this.warningMessage = data.warningMessage
                ?? 'All matching rows will be permanently deleted.';
        this.confirmLabel   = data.confirmLabel   ?? 'Continue';
        this.confirmIcon    = data.confirmIcon    ?? 'check';
    }

    hasSelection(): boolean {
        return this.selectedDataType !== '';
    }

    ngOnInit(): void { }

    onCloseClicked(): void {
        this.dialogRef.close();
    }
}
